<!--
 * @Author: 王枫叶
 * @Date: 2020-12-21 15:17:10
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-21 19:45:06
-->
<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="450px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
      >
        <el-form-item  prop="contentUrl">
          <iframe :src="params.contentUrl" width='100%' height='600' frameborder='1' ></iframe>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      flag: false,
      title:'',
      params: {
        contentUrl: "",

      },
      // 表单验证规则
      rules: {
      },
    };
  },

  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        contentUrl: "",
      };
    },
    // 打开
    open( data) {
      this.dialogVisible = true;
      this.params.contentUrl = ''+data.contentUrl;
      this.title=data.title
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .item-box {
    margin-left: 28px;
    width: 100%;
    display: flex;
    .item1 {
      flex: 1;
      .upload {
        position: relative;
        top: 35px;
        left: -90px;
      }
    }
    .item2 {
      flex: 3;
      width: 250px;
      position: relative;
      top: 0px;
      left: -60px;
    }
  }
}
</style>
